import { render, staticRenderFns } from "./LoadDocument.vue?vue&type=template&id=1aab4b05&"
import script from "./LoadDocument.vue?vue&type=script&lang=js&"
export * from "./LoadDocument.vue?vue&type=script&lang=js&"
import style0 from "./LoadDocument.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports